/* eslint-disable @typescript-eslint/no-explicit-any */
import equals from 'ramda/src/equals'
import { Row, TableState, ActionType } from 'react-table'

import { formatDate, isDate } from '_helpers/functions'

export const parseData = (val?: string) => {
  if (val && isDate(val)) {
    return formatDate(val)
  }

  return val
}

export const globalFilter = <Rows extends Row<any>[]>(
  rows: Rows,
  filterValue: string
): Rows =>
  rows.filter(row =>
    Object.values(row.original).some(val => {
      if (typeof val !== 'string') return !filterValue

      const parsedVal = parseData(val)

      return (
        parsedVal &&
        parsedVal.toLowerCase().includes(filterValue.toLowerCase().trim())
      )
    })
  ) as Rows

export const smartStateReducer = <D extends object>(
  newState: TableState<D>,
  action: ActionType,
  prevState: TableState<D>
): TableState<D> => {
  if (equals(newState, prevState)) {
    return prevState
  }

  return newState
}
